export type SideBarState = {
    value: boolean
};

export const initialSideBarState = {
    value: false
};